import { render, staticRenderFns } from "./Optimisation.vue?vue&type=template&id=99a89866&"
import script from "./Optimisation.vue?vue&type=script&lang=js&"
export * from "./Optimisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports